import React, { useEffect, useState, useRef, Suspense } from 'react';
interface LazySectionProps {
  children: ReactNode;
  /** How far before the viewport to start loading (px). Default 300 on desktop, 200 on mobile */
  rootMargin?: string;
  /** Minimum height placeholder to prevent CLS */
  minHeight?: string;
  /** Fallback while loading */
  fallback?: ReactNode;
  /** Optional id for anchor link scroll targets */
  id?: string;
}
export function LazySection({
  children,
  rootMargin,
  minHeight = '200px',
  fallback,
  id
}: LazySectionProps) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Smaller margin on mobile to save bandwidth
    const isMobile = window.innerWidth < 768;
    const margin = rootMargin || (isMobile ? '150px' : '400px');
    // If IntersectionObserver not supported, load immediately
    if (!('IntersectionObserver' in window)) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      rootMargin: `${margin} 0px ${margin} 0px`
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);
  return <div ref={ref} id={id} style={{
    contain: 'content'
  }} data-id="element-205">
      {isVisible ? <Suspense fallback={fallback || <div className="bg-dark" style={{
      minHeight
    }} aria-hidden="true" data-id="element-207" />} data-id="element-206">
          {children}
        </Suspense> : <div className="bg-dark" style={{
      minHeight
    }} aria-hidden="true" data-id="element-208" />}
    </div>;
}